module.exports = __webpack_public_path__ + "static/media/icon14@4x.d5498a47.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon14@4x.png
// module id = 1764
// module chunks = 0 1